import { render } from "./TeamTruckUpdates.vue?vue&type=template&id=45b51b66&scoped=true"
import script from "./TeamTruckUpdates.vue?vue&type=script&lang=js"
export * from "./TeamTruckUpdates.vue?vue&type=script&lang=js"

import "./TeamTruckUpdates.vue?vue&type=style&index=0&id=45b51b66&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b51b66"]])

export default __exports__